<template>
    <div>
        <!-- button (with tooltip) to enable/disable switchToNextNoValidatedDocumentAfterValidation param -->
        <v-tooltip location="top">
            <template v-slot:activator="{ props }">
                <v-btn-icon
                    v-bind="props"
                    icon="$oss-fast-forward"
                    size="x-small"
                    variant="flat"
                    :color="buttonColor"
                    class="mx-1 enlarge-oss-fast-forward"
                    data-cy="DocumentValidationSpeedRun-btn"
                    @click="onButtonClick"
                />
            </template>
            <span v-html="buttonTitle"></span>
        </v-tooltip>

        <!-- snackbar to display success message after validation of the last no validated document -->
        <v-snackbar v-model="displaySnackbar" color="success" timeout="5000">
            <p v-html="snackbarMessage"></p>
            <template v-slot:actions>
                <v-btn variant="text" color="whilte" @click="closeSnackbar()"> &times; </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script lang="ts">
import { Component, toNative, Model, Vue } from "vue-facing-decorator";

/**
 * Button to enable/disable the option to switch directly to the next
 * no validated document after current document validation.
 *
 * Includes SnackBar to display success message when validation of all documents is done
 */
@Component({})
export class DocumentValidationSpeedRun extends Vue {
    @Model({ default: false }) displaySnackbar: boolean;

    speedRunEnabled = false;

    buttonTitle = "";
    buttonColor: "grey" | "primary" = "grey";

    get snackbarMessage() {
        return this.$t("notification.document.allDocumentsValidated");
    }

    mounted() {
        const store_documentParams = this.$store.state?.documentFilter ?? {};

        this.speedRunEnabled =
            store_documentParams?.switchToNextNoValidatedDocumentAfterValidation ?? false;

        this.buttonTitle = this.getButtonTitle(this.speedRunEnabled);
        this.buttonColor = this.getButtonColor(this.speedRunEnabled);
    }

    /**
     * Toggle the switchToNextNoValidatedDocumentAfterValidation param in Vue state store
     */
    onButtonClick() {
        this.speedRunEnabled = !this.speedRunEnabled;

        this.$store.state.documentFilter.switchToNextNoValidatedDocumentAfterValidation =
            this.speedRunEnabled;

        this.buttonTitle = this.getButtonTitle(this.speedRunEnabled);
        this.buttonColor = this.getButtonColor(this.speedRunEnabled);
    }

    closeSnackbar() {
        this.displaySnackbar = false;
    }

    getButtonTitle(speedRunEnabled: boolean): string {
        const prefix = speedRunEnabled ? `Désactiver` : `Activer`;
        return this.$t("document.tooltip.validationSpeedRun", { prefix });
    }

    getButtonColor(speedRunEnabled: boolean): "primary" | "grey" {
        return speedRunEnabled ? "primary" : "grey";
    }
}

export default toNative(DocumentValidationSpeedRun);
</script>
